module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Download what you need","empty":"Empty directory"},"fr":{"title":"Télécharger ce dont vous avez besion","empty":"Le répertoir est vide"}}')
  delete Component.options._Ctor
}
